export const categoryOption = {
  GIFT: "Gift",
  GIFT_CARD: "Gift Card",
  CUSTOM: "Custom"
};
